import { render, staticRenderFns } from "./VIPDocumentsPopup.vue?vue&type=template&id=6997cc6f&"
import script from "./VIPDocumentsPopup.vue?vue&type=script&lang=js&"
export * from "./VIPDocumentsPopup.vue?vue&type=script&lang=js&"
import style0 from "./VIPDocumentsPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6997cc6f')) {
      api.createRecord('6997cc6f', component.options)
    } else {
      api.reload('6997cc6f', component.options)
    }
    module.hot.accept("./VIPDocumentsPopup.vue?vue&type=template&id=6997cc6f&", function () {
      api.rerender('6997cc6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UploadFile/VIPDocumentsPopup.vue"
export default component.exports